import jexl from 'jexl';

import { ExpEvalRequest, ExpEvalResult, ExpService } from '../api';
import { ROOT_VARIABLE } from './JEXLExpressionBuilder';
import { registerCustomFunctions } from './jexlUtils';

const CONTEXT_VARIABLES_VARIABLE = 'ctxVariables';

registerCustomFunctions();

class JEXLService implements ExpService {
  evaluate = (request: ExpEvalRequest): ExpEvalResult => {
    const context = {};
    context[ROOT_VARIABLE] = request.data;
    const variables = request.variables || {};
    context[CONTEXT_VARIABLES_VARIABLE] = variables;
    Object.keys(variables).forEach((key) => (context[key] = variables[key]));
    const value = jexl.evalSync(request.expression, context);
    return { value };
  };
}

const jexlService = new JEXLService();

export default jexlService;
